<template>
  <div class="st-header">
    <div class="st-header-content">
      <div class="st-header-left">
        <span v-if="backAble" @click="back">
          <span>
            <i class="el-icon-arrow-left"></i>
          </span>
          <span class="st-header-back">返回</span>
        </span>
        <span class="st-header-close" v-if="closeAble" @click="close">关闭</span>
        <span>&emsp;</span>
      </div>
      <div class="st-header-center">{{ title }}</div>
      <div class="st-header-right">
        <slot name="header-right">
        </slot>
				<span v-if="moreOp.length > 0" @click.stop="openMoreop" style="font-size: 24px;margin: 0px 10px 0px 15px;vertical-align: bottom;">
					<i class="el-icon-s-operation"></i>
				</span>
      </div>
    </div>
		<div class="page-more" v-if="showMoreOp">
			<ul>
				<li v-for="(item, i) in moreOp" :key="i" @click="command(item.val)">
					{{ item.title }}
				</li>
			</ul>
		</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: () => {
        return '';
      }
    },
    backAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    closeAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
		close: {
			type: Function,
			default: () => {
				this.back();
			}
		},
		moreOp: {
			type: Array,
			default: () => {
				return [];
			}
		},

  },
  data() {
    return {
      showMoreOp: false,
    };
  },
  watch: {},

  methods: {
    init() {},
    back() {
      this.$router.go(-1);
    },
		openMoreop() {
			this.showMoreOp = true;
		},
		command(val) {
			this.$emit('command', val)
		},
  },
  created() {
    this.init();
  },
  mounted() {
  	document.addEventListener('click', () => { this.showMoreOp = false; })
  },
};
</script>

<style lang="scss" scoped>
.page-more{
	position: fixed;
	top: 40px;
	background-color: white;
	z-index: 9999;
	width: 100px;
	text-align: center;
	padding-top: 8px;
	right: 2px;
	border-radius: 5px;
	box-shadow: 0px 1px 3px 0px	;
	padding-bottom: 3px;
}

.page-more li {
	padding: 5px 8px;
}
.page-more li:after{
	content: '';
	display: block;
	width: 90%;
	border-bottom: 1px solid;
	margin-left: 3px;
}

.page-more:before {
		content: '';
		position: absolute;
		border-style: solid;
		border-width: 0 8px 8px 8px;
		border-color: transparent transparent #fff transparent;
		top: -8px;
		right: 12px;
		transform: translateX(-50%);
}

.page-more li:last-child:after {
	display: none;
}

.st-header {
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;

  .st-header-content {
    width: 100%;
    position: fixed;
    z-index: 10;
    background-color: white;
  }

  .st-header-left {
    float: left;
    width: 25%;
    .el-icon-arrow-left {
      font-size: 24px;
      font-weight: bold;
      transform: translateY(4px);
    }
    .st-header-close {
      margin-left: 14px;
    }
  }

  .st-header-center {
    float: left;
    width: 35%;
    text-align: center;
		padding-left: 5%;
  }

  .st-header-right {
    float: right;
    width: 30%;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
